import type { ThemeConfig } from 'antd';

// Tokens del tema antd. Si en algun momento aparece una guia de branding de
// AsiContadores, los cambios van aca.
export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#1a3a5c',
    borderRadius: 6,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#1a3a5c',
    },
    Menu: {
      darkItemBg: '#1a3a5c',
      darkItemSelectedBg: '#0d6efd',
    },
  },
};
